// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCWLQ_YlViaavsP6hjnay5AGGobfhy9kBg",
  authDomain: "scitility.firebaseapp.com",
  projectId: "scitility",
  storageBucket: "scitility.appspot.com",
  messagingSenderId: "1012914040525",
  appId: "1:1012914040525:web:68d6a2fe5ecf288aa48384",
  measurementId: "G-7SW4VLD6ME"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app)

export {app, analytics, auth}